var _g, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path4, _path5, _path6, _path7, _circle, _circle2, _circle3, _circle4, _rect9, _rect10, _circle5, _circle6, _circle7, _path8, _rect11, _rect12, _rect13, _path9, _path10, _rect14, _path11, _path12, _path13, _path14, _path15, _path16, _circle8, _circle9, _circle10, _path17, _path18, _path19, _circle11, _circle12, _path20, _circle13, _circle14, _path21, _path22, _path23, _path24, _path25, _path26, _circle15, _path27, _path28, _path29, _circle16, _path30, _path31, _path32, _path33, _path34, _path35, _rect15, _rect16, _path36, _path37, _rect17, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _path51;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFte1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.3646 427.186C83.3646 427.186 -7.40643 319.2 19.7846 291.563C46.9756 263.926 92.6736 294.093 84.8456 263.293C77.0176 232.493 45.8266 202.615 58.4316 179.242C73.5626 151.187 117.839 173.95 139.28 183.774C179.141 202.038 223.313 204.064 208.005 178.521C192.697 152.978 152.621 128.021 167.157 113.463C186.939 93.653 295.719 166.986 342.274 224.412C370.137 258.781 390.444 234.866 387.623 212.786C385.83 198.752 366.094 169.793 386.797 156.686C406.754 144.052 453.364 183.204 469.197 207.379C510.655 270.679 442.777 426.571 442.777 426.571L83.3646 427.186Z",
    fill: "#C5CEDA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M222.349 426.661H254.116V416.908H232.977L220.845 422.063C219.916 422.384 219.27 423.232 219.208 424.213V424.213C219.208 425.565 220.614 426.661 222.349 426.661Z",
    fill: "#192335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M264.806 426.661H296.573V416.908H275.433L263.299 422.063C262.369 422.384 261.723 423.231 261.661 424.213V424.213C261.664 425.565 263.071 426.661 264.806 426.661Z",
    fill: "#192335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M260.776 177.312V231.501H121.756V130.303H260.776V177.312",
    fill: "#E1E1E1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 121.847,
    y: 99.6068,
    width: 3.23,
    height: 9.06,
    transform: "rotate(-0.187 121.847 99.6068)",
    fill: "#0134A0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 106.224,
    y: 104.714,
    width: 3.231,
    height: 9.06,
    transform: "rotate(-30.184 106.224 104.714)",
    fill: "#0134A0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 95.249,
    y: 116.947,
    width: 3.23,
    height: 9.06,
    transform: "rotate(-60.185 95.249 116.947)",
    fill: "#0134A0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 91.8525,
    y: 129.799,
    width: 9.059,
    height: 3.23,
    transform: "rotate(-0.187 91.8525 129.799)",
    fill: "#0134A0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 95.3428,
    y: 145.857,
    width: 9.06,
    height: 3.23,
    transform: "rotate(-30.182 95.3428 145.857)",
    fill: "#0134A0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 142.329,
    y: 118.525,
    width: 9.059,
    height: 3.23,
    transform: "rotate(-30.182 142.329 118.525)",
    fill: "#0134A0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 106.397,
    y: 158.019,
    width: 9.06,
    height: 3.231,
    transform: "rotate(-60.193 106.397 158.019)",
    fill: "#0134A0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 133.423,
    y: 110.857,
    width: 9.06,
    height: 3.231,
    transform: "rotate(-60.193 133.423 110.857)",
    fill: "#0134A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M260.779 142.6V156.772H121.758V130.305H260.779V142.6",
    fill: "#4A90E2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129.181 129.611H137.74V231.504H121.756V129.611H129.181",
    fill: "#055CC0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.243 233.015H263.228V128.1H120.243V233.015ZM260.205 229.992H123.266V131.123H260.205V229.992Z",
    fill: "#0134A0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.243 233.015H263.228V128.1H120.243V233.015ZM260.205 229.992H123.266V131.123H260.205V229.992Z",
    fill: "#0134A0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 129.748,
    cy: 156.772,
    r: 3.955,
    fill: "#E6E6E8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.748,
    cy: 169.139,
    r: 3.955,
    fill: "#E6E6E8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.748,
    cy: 181.506,
    r: 3.955,
    fill: "#E6E6E8"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.748,
    cy: 193.873,
    r: 3.955,
    fill: "#E6E6E8"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 115.727,
    y: 231.503,
    width: 196.796,
    height: 8.464,
    fill: "#0134A0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 115.727,
    y: 231.503,
    width: 196.796,
    height: 8.464,
    fill: "#0134A0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 261.455,
    cy: 292.721,
    r: 11.28,
    fill: "#AB9AF7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 270.751,
    cy: 290.488,
    r: 13.313,
    fill: "#AB9AF7"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 313.94,
    cy: 290.492,
    r: 13.313,
    fill: "#AB9AF7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M327.912 277.179L327.259 290.492L327.227 291.145C326.879 298.236 321.027 303.807 313.927 303.805H270.775C263.675 303.807 257.823 298.236 257.475 291.145L257.443 290.492L256.79 277.179L327.912 277.179Z",
    fill: "#AB9AF7"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 77.3486,
    y: 237.782,
    width: 369.993,
    height: 10.573,
    fill: "#0134A0"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 103.216,
    y: 438.098,
    width: 183.74,
    height: 1.453,
    fill: "#293F51"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 311.323,
    y: 438.098,
    width: 93.918,
    height: 1.453,
    fill: "#293F51"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M109.264 247.389L108.278 256.785L89.5897 427.227H84.8457L98.8727 247.389H109.264V247.389Z",
    fill: "#0134A0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M407.834 247.389L408.821 256.785L427.508 427.227H432.252L418.226 247.389H407.834V247.389Z",
    fill: "#0134A0"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 16.3232,
    y: 426.468,
    width: 470.4,
    height: 1.453,
    fill: "#293F51"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.46 195.191H254.8V191.811H239.46V195.191ZM254.5 194.891H239.762L239.761 192.113H254.5V194.891Z",
    fill: "#055CC0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M276.564 317.412L219.269 317.653L218.378 281.506L275.513 276.344L276.564 317.412V317.412Z",
    fill: "#658FDF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M225.551 213.648L300.888 228.397L299.77 239.995L295.815 239.996L289.971 239.995L223.013 240.014L225.551 213.648V213.648Z",
    fill: "#C9DEF6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M299.773 239.991L300.891 228.393L295.818 227.4V239.992L299.773 239.991V239.991Z",
    fill: "#C9DEF6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M278.538 155.513H314.08V116.587C314.08 104.747 304.481 95.1486 292.641 95.148V95.148C281.203 95.148 270.806 104.127 270.253 115.548L268.814 145.303C268.685 147.964 269.651 150.562 271.489 152.492C273.326 154.421 275.874 155.513 278.538 155.513Z",
    fill: "#E6BBA6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M305.107 186.261H296.266C291.312 186.261 287.295 182.245 287.295 177.29V145.617H314.074V177.291C314.074 182.244 310.06 186.259 305.107 186.261V186.261Z",
    fill: "#E6BBA6"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 300.688,
    cy: 172.87,
    r: 13.391,
    fill: "#E6BBA6"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 219.509,
    cy: 292.721,
    r: 11.28,
    fill: "#4A90E2"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 219.509,
    cy: 292.721,
    r: 11.28,
    fill: "#658FDF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M256.263 417.552L238.398 292.076L208.273 293.843L227.351 417.552H256.263V417.552Z",
    fill: "#658FDF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M298.401 417.552L280.536 292.076L250.411 293.843L269.489 417.552H298.401V417.552Z",
    fill: "#658FDF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M333.962 277.179C333.968 281.742 333.09 286.263 331.377 290.492H265.427C260.058 277.191 263.206 261.967 273.409 251.886C283.612 241.805 298.872 238.841 312.108 244.369C325.343 249.897 333.961 262.836 333.962 277.179Z",
    fill: "#AB9AF7"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 298.398,
    cy: 277.179,
    r: 9.753,
    fill: "#40327A"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.989,
    cy: 226.695,
    r: 13.3089,
    transform: "rotate(-4.70181 373.989 226.695)",
    fill: "#C9DEF6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M313.691 201.198L366.263 237.585L383.379 217.375L338.787 171.565L313.691 201.198V201.198Z",
    fill: "#C9DEF6"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 324.793,
    cy: 185.16,
    r: 19.506,
    transform: "rotate(-18.744 324.793 185.16)",
    fill: "#C9DEF6"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 312.786,
    cy: 238.673,
    r: 7.802,
    transform: "rotate(-56.899 312.786 238.673)",
    fill: "#FF95A9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M305.514 235.261C305.059 237.584 303.25 239.404 300.93 239.873C298.61 240.342 296.236 239.367 294.915 237.403C293.594 235.439 293.586 232.873 294.895 230.901C296.204 228.929 298.572 227.939 300.895 228.394C302.418 228.692 303.761 229.583 304.627 230.871C305.493 232.159 305.812 233.738 305.514 235.261V235.261Z",
    fill: "#FF95A9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M309.196 245.603L297.078 239.334L300.894 228.394L314.284 231.015L309.196 245.603V245.603Z",
    fill: "#FF95A9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M236.056 229.256C234.643 236.463 227.656 241.161 220.448 239.749C213.241 238.337 208.542 231.351 209.952 224.143C211.363 216.935 218.348 212.235 225.556 213.644C229.019 214.321 232.072 216.346 234.041 219.275C236.01 222.203 236.735 225.793 236.056 229.256V229.256Z",
    fill: "#C9DEF6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M283.115 201.185L230.584 237.631L213.445 217.44L257.986 171.581L283.115 201.185V201.185Z",
    fill: "#C9DEF6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M283.119 201.184L239.502 231.444L221.009 209.648L257.985 171.578L283.119 201.184V201.184Z",
    fill: "#C9DEF6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M313.691 201.198L357.341 231.41L375.81 209.594L338.792 171.565L313.691 201.198V201.198Z",
    fill: "#C9DEF6"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 271.996,
    cy: 185.158,
    r: 19.506,
    transform: "rotate(-71.334 271.996 185.158)",
    fill: "#C9DEF6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M338.726 179.976L333.957 277.176H262.838L258.069 179.976C257.886 176.243 259.241 172.598 261.818 169.891C264.396 167.184 267.97 165.652 271.707 165.652H325.088C328.826 165.652 332.4 167.184 334.977 169.891C337.555 172.598 338.91 176.243 338.726 179.976Z",
    fill: "#C9DEF6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M334.479 277.661L377.873 427.183H382.859L347.376 277.661H334.479V277.661Z",
    fill: "#0134A0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M289.105 277.661L245.711 427.183H240.724L276.207 277.661H289.105V277.661Z",
    fill: "#0134A0"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 311.792,
    cy: 256.333,
    r: 73.078,
    fill: "#000B64"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M323.643 210.331H299.943C298.632 210.332 297.375 209.813 296.448 208.886C295.521 207.96 295 206.704 295 205.393V205.393C295 202.666 297.211 200.455 299.938 200.455H323.638C324.948 200.455 326.203 200.975 327.129 201.901C328.055 202.827 328.575 204.083 328.575 205.393V205.393C328.576 208.118 326.368 210.328 323.643 210.331V210.331Z",
    fill: "#C9DEF6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M265.528 97.9621V109.538C265.525 110.412 265.633 111.282 265.85 112.128H287.629V86.2791H277.212C274.113 86.278 271.141 87.5085 268.95 89.6997C266.758 91.8909 265.528 94.8631 265.528 97.9621V97.9621Z",
    fill: "#8896AA"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M324.791 128.139H302.401V91.487H309.791C318.075 91.487 324.791 98.2028 324.791 106.487V128.139Z",
    fill: "#8896AA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M267.199 109.647H290.351C299.4 109.637 306.733 102.303 306.743 93.254C306.775 90.4504 305.297 87.8461 302.875 86.4351C300.452 85.024 297.458 85.024 295.035 86.4351C292.612 87.8461 291.134 90.4504 291.166 93.254C291.166 93.7039 290.801 94.0685 290.351 94.069H267.199V109.647Z",
    fill: "#8896AA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M275.473 101.856H287.48C290.284 101.888 292.888 100.41 294.299 97.9875C295.71 95.5646 295.71 92.5704 294.299 90.1476C292.888 87.7247 290.284 86.2472 287.48 86.279H275.473C272.669 86.2472 270.065 87.7247 268.654 90.1476C267.243 92.5704 267.243 95.5646 268.654 97.9875C270.065 100.41 272.669 101.888 275.473 101.856Z",
    fill: "#8896AA"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M263.273 106.9C263.274 113.385 268.531 118.642 275.016 118.643C281.502 118.643 287.629 113.385 287.629 106.9C287.629 100.415 281.499 95.156 275.016 95.156C271.902 95.156 268.915 96.3933 266.713 98.5958C264.51 100.798 263.273 103.785 263.273 106.9Z",
    fill: "#8896AA"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 307.69,
    y: 115.697,
    width: 32.453,
    height: 12.17,
    transform: "rotate(-180 307.69 115.697)",
    fill: "#8896AA"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 306.758,
    y: 131.059,
    width: 25.07,
    height: 15.523,
    transform: "rotate(-180 306.758 131.059)",
    fill: "#8896AA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M311.12 152.798H298.82C292.586 152.796 287.532 147.742 287.53 141.508V124.798H324.79V139.138C324.787 146.685 318.667 152.8 311.12 152.798V152.798Z",
    fill: "#8896AA"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M287.528 125.217H282.364C277.195 125.217 273.005 121.027 273.005 115.858V111.246H287.528V125.217Z",
    fill: "#8896AA"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 282.367,
    y: 158.174,
    width: 35,
    height: 10.965,
    fill: "#C9DEF6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M281.688 136.772H275.846V125.089H281.688C284.914 125.089 287.529 127.704 287.53 130.93V130.93C287.53 134.156 284.914 136.772 281.688 136.772V136.772Z",
    fill: "#E6BBA6"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.753 148.324C162.514 147.751 162.403 147.134 162.428 146.514C162.425 146.171 162.445 145.829 162.487 145.489H170.453C170.478 145.227 170.496 144.994 170.51 144.789C170.522 144.584 170.528 144.363 170.528 144.126C170.531 143.629 170.456 143.135 170.305 142.662C170.166 142.228 169.944 141.826 169.651 141.477C169.355 141.134 168.985 140.863 168.569 140.684C168.091 140.483 167.576 140.385 167.058 140.395C166.293 140.378 165.537 140.561 164.866 140.927C164.247 141.273 163.711 141.751 163.298 142.327C162.874 142.92 162.559 143.583 162.366 144.285C162.162 145.004 162.058 145.748 162.058 146.496C162.054 147.017 162.126 147.535 162.272 148.035C162.404 148.493 162.63 148.918 162.935 149.285C163.239 149.644 163.622 149.928 164.054 150.115C164.549 150.324 165.083 150.426 165.621 150.415C166.634 150.464 167.633 150.161 168.448 149.556C169.208 148.909 169.735 148.031 169.948 147.056H169.555C169.358 147.962 168.85 148.771 168.119 149.341C167.377 149.841 166.495 150.092 165.601 150.059C165.263 150.054 164.927 150.007 164.601 149.92C164.222 149.821 163.869 149.643 163.565 149.397C163.215 149.107 162.937 148.74 162.753 148.324ZM170.147 144.13C170.147 144.313 170.14 144.481 170.128 144.63H170.132C170.117 144.795 170.091 144.959 170.054 145.12H162.554C162.66 144.54 162.838 143.976 163.085 143.44C163.317 142.934 163.629 142.468 164.009 142.06C164.793 141.217 165.899 140.749 167.05 140.773C167.518 140.762 167.983 140.854 168.412 141.043C168.784 141.213 169.115 141.461 169.382 141.771C169.648 142.084 169.845 142.45 169.96 142.844C170.086 143.261 170.149 143.694 170.147 144.13Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M183.023 147.214C182.733 147.864 182.326 148.455 181.823 148.958C181.322 149.449 180.73 149.836 180.079 150.097C179.354 150.38 178.581 150.519 177.803 150.507C176.963 150.516 176.132 150.341 175.368 149.994C174.641 149.661 173.994 149.178 173.468 148.576C172.92 147.94 172.499 147.205 172.228 146.411C171.921 145.527 171.77 144.596 171.78 143.66C171.783 142.824 171.899 141.993 172.125 141.188C172.346 140.366 172.716 139.592 173.216 138.903C173.728 138.205 174.391 137.631 175.156 137.224C176.05 136.766 177.045 136.541 178.049 136.57C178.842 136.553 179.63 136.702 180.362 137.008C180.975 137.27 181.535 137.643 182.013 138.108C182.429 138.513 182.768 138.991 183.013 139.517C183.219 139.943 183.339 140.406 183.368 140.878H182.994C182.953 140.378 182.807 139.891 182.565 139.451C182.306 138.972 181.961 138.546 181.548 138.192C181.094 137.804 180.577 137.497 180.019 137.286C178.463 136.735 176.748 136.85 175.28 137.604C174.558 138.017 173.937 138.584 173.461 139.265C173.002 139.925 172.663 140.66 172.461 141.438C172.264 142.162 172.16 142.908 172.153 143.658C172.15 144.487 172.276 145.312 172.526 146.102C172.758 146.856 173.131 147.558 173.626 148.172C174.113 148.77 174.719 149.26 175.407 149.61C176.152 149.98 176.975 150.166 177.807 150.151C178.541 150.163 179.27 150.029 179.952 149.758C180.566 149.511 181.124 149.143 181.594 148.676C182.064 148.202 182.443 147.646 182.713 147.035C183.004 146.383 183.199 145.692 183.292 144.983H183.665C183.562 145.754 183.345 146.506 183.023 147.214Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.073 141.31C185.769 141.594 185.53 141.941 185.373 142.327C185.21 142.728 185.115 143.153 185.093 143.585H185.467C185.481 142.793 185.818 142.041 186.4 141.504C187.066 140.977 187.904 140.715 188.751 140.768C189.267 140.747 189.781 140.832 190.262 141.019C190.596 141.157 190.888 141.379 191.11 141.663C191.299 141.915 191.424 142.21 191.474 142.521C191.523 142.819 191.548 143.12 191.548 143.421C191.567 143.714 191.492 144.005 191.334 144.252C191.163 144.464 190.927 144.615 190.662 144.681C190.282 144.786 189.891 144.849 189.497 144.868C189.023 144.897 188.456 144.93 187.797 144.968C187.396 144.994 186.998 145.046 186.604 145.126C186.225 145.2 185.864 145.346 185.54 145.556C185.221 145.771 184.961 146.062 184.784 146.404C184.573 146.853 184.474 147.346 184.495 147.841C184.445 148.591 184.775 149.316 185.372 149.772C186.061 150.232 186.879 150.457 187.705 150.416C188.173 150.419 188.638 150.352 189.085 150.216C189.486 150.096 189.867 149.917 190.214 149.685C190.527 149.476 190.804 149.218 191.035 148.921C191.243 148.65 191.404 148.346 191.511 148.021H191.547V149.27C191.512 149.553 191.629 149.833 191.855 150.007C192.07 150.142 192.319 150.212 192.573 150.207H193.133V149.834C193.009 149.847 192.876 149.856 192.733 149.862C192.599 149.869 192.464 149.856 192.333 149.825C192.217 149.8 192.112 149.738 192.033 149.648C191.949 149.528 191.909 149.383 191.921 149.237V143.137C191.924 142.686 191.829 142.241 191.641 141.831C191.479 141.499 191.243 141.209 190.951 140.983C190.655 140.761 190.313 140.605 189.951 140.526C189.557 140.437 189.155 140.394 188.751 140.395C188.222 140.385 187.695 140.467 187.193 140.637C186.778 140.783 186.397 141.012 186.073 141.31ZM190.933 144.975C191.163 144.904 191.365 144.765 191.512 144.575L191.544 144.576V146.348C191.545 146.82 191.459 147.287 191.292 147.728C191.128 148.17 190.874 148.573 190.546 148.912C190.198 149.267 189.782 149.55 189.324 149.743C188.799 149.963 188.234 150.071 187.664 150.06C187.218 150.071 186.772 150.003 186.349 149.86C186.03 149.751 185.736 149.581 185.481 149.36C185.266 149.167 185.102 148.923 185.005 148.651C184.913 148.39 184.867 148.116 184.866 147.839C184.849 147.412 184.931 146.988 185.108 146.599C185.256 146.297 185.481 146.04 185.761 145.853C186.048 145.667 186.368 145.54 186.704 145.479C187.064 145.41 187.428 145.363 187.794 145.339C188.168 145.315 188.55 145.296 188.942 145.283C189.307 145.273 189.672 145.242 190.033 145.19C190.34 145.148 190.641 145.076 190.933 144.975Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M194.086 150.208V140.619H194.46V142.988H194.497C194.583 142.631 194.721 142.289 194.907 141.972C195.099 141.649 195.353 141.367 195.653 141.141C195.989 140.893 196.365 140.703 196.764 140.581C197.25 140.438 197.757 140.375 198.264 140.395V140.769C197.681 140.718 197.095 140.811 196.557 141.039C196.097 141.242 195.691 141.55 195.372 141.939C195.056 142.327 194.822 142.775 194.682 143.255C194.533 143.751 194.457 144.267 194.458 144.785V150.213L194.086 150.208Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.627 148.734C199.317 148.299 199.092 147.808 198.964 147.289C198.817 146.7 198.739 146.095 198.732 145.488H206.754C206.779 144.848 206.712 144.208 206.554 143.588C206.411 143.004 206.158 142.453 205.808 141.964C205.461 141.487 205.007 141.098 204.483 140.826C203.885 140.527 203.222 140.379 202.553 140.397C201.441 140.403 200.383 140.881 199.643 141.712C199.237 142.176 198.921 142.71 198.709 143.289C198.463 143.97 198.343 144.691 198.355 145.415C198.35 146.085 198.432 146.753 198.598 147.402C198.742 147.978 198.996 148.521 199.344 149.002C199.682 149.458 200.129 149.82 200.644 150.056C201.246 150.319 201.9 150.441 202.556 150.411C203.557 150.442 204.537 150.114 205.317 149.487C206.086 148.83 206.562 147.895 206.641 146.887H206.268C206.179 147.811 205.734 148.664 205.027 149.266C204.308 149.813 203.421 150.093 202.518 150.059C201.92 150.077 201.326 149.956 200.783 149.704C200.324 149.48 199.927 149.147 199.627 148.734ZM205.42 142.056C205.745 142.47 205.989 142.941 206.138 143.445C206.302 143.988 206.384 144.552 206.38 145.119H198.731C198.758 144.5 198.884 143.888 199.104 143.309C199.296 142.805 199.577 142.341 199.934 141.937C200.266 141.566 200.674 141.27 201.129 141.069C201.591 140.868 202.09 140.766 202.593 140.769C203.159 140.757 203.721 140.875 204.234 141.113C204.696 141.334 205.101 141.656 205.42 142.056Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.258 137.923C220.423 137.18 219.322 136.807 218.207 136.888H212.368V150.208H214.14V144.761H218.207C219.322 144.854 220.426 144.483 221.258 143.735C222.637 142.043 222.637 139.615 221.258 137.923ZM219.819 142.652C219.185 143.127 218.396 143.347 217.607 143.268H214.137V138.38H217.607C218.396 138.313 219.182 138.536 219.819 139.006C220.309 139.479 220.565 140.144 220.519 140.824C220.564 141.506 220.308 142.174 219.819 142.652Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.395 138.455C232.08 137.336 230.38 136.774 228.657 136.888H224.083V150.208H228.654C229.632 150.23 230.605 150.072 231.526 149.742C232.293 149.461 232.98 148.997 233.526 148.39C234.07 147.758 234.466 147.011 234.683 146.206C234.945 145.237 235.07 144.235 235.055 143.231C235.196 141.477 234.594 139.744 233.395 138.455ZM229.552 148.669C229.304 148.698 229.055 148.713 228.806 148.716L225.859 148.72V138.384H228.844C229.55 138.364 230.254 138.481 230.915 138.73C231.451 138.942 231.923 139.289 232.286 139.737C232.655 140.208 232.916 140.754 233.051 141.337C233.215 142.037 233.293 142.754 233.285 143.473C233.299 144.181 233.214 144.888 233.033 145.573C232.894 146.085 232.677 146.572 232.389 147.018C232.155 147.376 231.854 147.687 231.503 147.932C231.193 148.146 230.857 148.318 230.503 148.445C230.196 148.557 229.877 148.632 229.552 148.669Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M193.976 191.722H189.157V186.303H193.976V181.483H199.396V186.303H204.215V191.722H199.396V196.499L193.976 196.541V191.722V191.722Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M189.564 209.57V203.608C189.487 200.916 188.344 198.365 186.387 196.516C182.855 192.959 181.41 187.829 182.568 182.951C183.806 177.636 187.954 173.483 193.268 172.24C194.392 171.982 195.542 171.85 196.695 171.848C204.705 171.857 211.196 178.349 211.205 186.359C211.21 190.174 209.692 193.834 206.987 196.525C205.285 198.145 204.186 200.297 203.873 202.625L203.88 209.577L189.564 209.57Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.009 171.138C194.216 170.859 195.45 170.718 196.688 170.716L196.691 170.714C205.327 170.724 212.325 177.722 212.335 186.358C212.343 190.474 210.705 194.422 207.787 197.324C206.3 198.737 205.323 200.603 205.01 202.63V210.7H202.743H190.699H188.431V203.61C188.353 201.218 187.328 198.955 185.582 197.318C181.6 193.319 180.089 187.482 181.629 182.053C183.169 176.624 187.521 172.45 193.009 171.138ZM206.148 176.899C203.639 174.39 200.236 172.981 196.688 172.981V172.983C195.621 172.984 194.557 173.107 193.516 173.347C188.832 174.477 185.121 178.045 183.81 182.682C182.499 187.319 183.791 192.302 187.189 195.718C189.362 197.778 190.625 200.617 190.698 203.61V208.439H202.741V202.492C203.09 199.912 204.303 197.526 206.18 195.723C208.67 193.243 210.069 189.872 210.065 186.358C210.066 182.81 208.656 179.408 206.148 176.899Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M197.161 210.373H196.405V203.273C196.404 201.948 196.907 200.671 197.813 199.704C198.589 198.877 199.02 197.786 199.018 196.652V195.209C199.018 194.952 198.81 194.744 198.553 194.744H193.599V189.925H188.78V183.751H193.599V178.93H199.773V183.751H204.593V189.925H199.773V192.677H199.018V189.169H203.837V184.507H199.018V179.686H194.355V184.507H189.535V189.169H194.355V193.989H198.555C199.229 193.99 199.775 194.535 199.775 195.209V196.652C199.777 197.977 199.274 199.254 198.367 200.221C197.594 201.049 197.165 202.14 197.167 203.273L197.161 210.373Z",
    fill: "#055CC0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M190.324 218.319L192.153 220.628C193.189 222.107 194.88 222.989 196.686 222.991C198.491 222.994 200.185 222.118 201.225 220.642L203.075 218.319L190.324 218.319Z",
    fill: "#4A90E2"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 218.002,
    y: 186.894,
    width: 5.458,
    height: 2.267,
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 169.939,
    y: 186.894,
    width: 5.458,
    height: 2.267,
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 213.269,
    y: 174.59,
    width: 5.458,
    height: 2.266,
    transform: "rotate(-35.989 213.269 174.59)",
    fill: "white"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 174.437,
    y: 202.749,
    width: 5.45761,
    height: 2.26625,
    transform: "rotate(-36.0105 174.437 202.749)",
    fill: "white"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 202.206,
    y: 167.417,
    width: 5.457,
    height: 2.266,
    transform: "rotate(-72.014 202.206 167.417)",
    fill: "white"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 187.354,
    y: 162.926,
    width: 2.266,
    height: 5.457,
    transform: "rotate(-18.009 187.354 162.926)",
    fill: "white"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 174.385,
    y: 173.216,
    width: 2.266,
    height: 5.457,
    transform: "rotate(-54.001 174.385 173.216)",
    fill: "white"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 213.269,
    y: 201.467,
    width: 2.266,
    height: 5.458,
    transform: "rotate(-54.01 213.269 201.467)",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M188.391 207.534H204.983V215.434C204.983 217.754 203.102 219.634 200.783 219.634H192.592C190.272 219.634 188.392 217.754 188.392 215.434V207.534L188.391 207.534Z",
    fill: "#4A90E2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFte1);
export default __webpack_public_path__ + "static/media/FTE1.afe43a8fa1f1c26b4a574ff222498364.svg";
export { ForwardRef as ReactComponent };